import { useState, useEffect, useCallback } from 'react'
import { fetchContentfulEntries } from '../lib/contentful'

export interface SubService {
  id: string
  name: string
  description: string
  parentServiceId: string
}

// Contentful field shape — adjust field IDs to match your Contentful model
interface ContentfulSubServiceFields {
  subServiceName?: string
  name?: string
  description?: string
  parentService?: {
    sys: { id: string }
  }
  [key: string]: any
}

function mapContentfulSubService(entry: {
  sys: { id: string }
  fields: ContentfulSubServiceFields
}): SubService {
  return {
    id: entry.sys.id,
    name: entry.fields.subServiceName || entry.fields.name || '',
    description:
      typeof entry.fields.description === 'string'
        ? entry.fields.description
        : '',
    parentServiceId: entry.fields.parentService?.sys?.id || '',
  }
}

export function useSubServices(parentServiceId?: string) {
  const [subServices, setSubServices] = useState<SubService[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const fetchSubServices = useCallback(async () => {
    setLoading(true)
    setError(false)
    try {
      const entries = await fetchContentfulEntries<ContentfulSubServiceFields>(
        'serviceSpecialities',
      )

      console.log(
        '[SubServices] Raw entries:',
        entries.map((e) => ({
          id: e.sys.id,
          fields: Object.keys(e.fields),
          allFields: e.fields,
          parentRef: e.fields.parentService?.sys?.id,
        })),
      )

      const mapped = entries.map(mapContentfulSubService)

      // Filter by parent service if provided
      const filtered = parentServiceId
        ? mapped.filter((s) => s.parentServiceId === parentServiceId)
        : mapped

      setSubServices(filtered)
    } catch (err) {
      console.error('Failed to fetch sub-services:', err)
      setError(true)
      setSubServices([])
    } finally {
      setLoading(false)
    }
  }, [parentServiceId])

  useEffect(() => {
    fetchSubServices()
  }, [fetchSubServices])

  return { subServices, loading, error, refetch: fetchSubServices }
}
